import { validator } from '@ally/validator';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '../../../constants';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
var IsWithinMinDate = function (date, _a) {
    var minDeliveryDate = _a.minDeliveryDate;
    return dayjs
        .tz(date, DATE_PICKER_FORMAT, SERVER_TIMEZONE)
        .isSameOrAfter(minDeliveryDate, 'day');
};
export var IsWithinMinDateNonExternalErrorMessage = "You can't enter a date in the past. Please enter today's date or a future date.";
export var IsWithinMinDateExternalErrorMessage = 'Date entered is not valid for this transfer speed.';
export var IsWithinMinDateErrorMessage = function (_, _a) {
    var transferType = _a.transferType;
    return transferType === 'EXTERNAL'
        ? IsWithinMinDateExternalErrorMessage
        : IsWithinMinDateNonExternalErrorMessage;
};
export var IsWithinMinDateValidator = validator(IsWithinMinDate, IsWithinMinDateErrorMessage);
//# sourceMappingURL=IsWithinMinDate.js.map